export const PhoneReg = /^1[3-9][0-9]{9}$/
export const PasswordReg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?\.()\-_=+<>~^&])[A-Za-z\d$@$!%*#?\.()\-_=+<>~^&]{8,20}$/

export function validPhone(_, value, cb) {
  if (PhoneReg.test(value)) {
    return Promise.resolve()
  }
  return Promise.reject('请输入正确格式的手机号')
}
export function validPassword(_, value) {
  if (PasswordReg.test(value)) {
    return Promise.resolve()
  }
  return Promise.reject('8-20位包含字母，数字和特殊字符的密码')
}
